export const translationsConst = {
  byeBias: 'ByeBias',
};
